if (!customElements.get('pp-announcement-bar')) {
  class PpAnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.timer = null;
      this.index = 0;
      this.paused = false;
      this.onBlockSelect = this.onBlockSelect.bind(this);
      this.onBlockDeselect = this.onBlockDeselect.bind(this);
      this.onPause = () => {
        this.paused = true;
        this.stop();
      };
      this.onResume = () => {
        this.paused = false;
        this.start();
      };
    }

    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.pp-announcement__slide'));
      if (this.slides.length < 2) return;

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.interval = parseInt(this.dataset.interval, 10) || 4000;
      this.autoplay = this.dataset.autoplay === 'true' && !reducedMotion;

      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', () => this.go(this.index - 1, true));
      if (next) next.addEventListener('click', () => this.go(this.index + 1, true));

      this.addEventListener('mouseenter', this.onPause);
      this.addEventListener('mouseleave', this.onResume);
      this.addEventListener('focusin', this.onPause);
      this.addEventListener('focusout', this.onResume);

      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

      this.start();
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    start() {
      this.stop();
      if (!this.autoplay || this.paused) return;
      this.timer = window.setInterval(() => this.go(this.index + 1), this.interval);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    go(newIndex, userTriggered) {
      const count = this.slides.length;
      this.index = (newIndex + count) % count;

      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        if (active) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }
        const link = slide.querySelector('a');
        if (link) {
          if (active) {
            link.removeAttribute('tabindex');
          } else {
            link.setAttribute('tabindex', '-1');
          }
        }
      });

      if (userTriggered) this.start();
    }

    onBlockSelect(event) {
      const slide = this.slides.indexOf(event.target);
      if (slide === -1) return;
      this.paused = true;
      this.stop();
      this.go(slide);
    }

    onBlockDeselect(event) {
      if (this.slides.indexOf(event.target) === -1) return;
      this.paused = false;
      this.start();
    }
  }

  customElements.define('pp-announcement-bar', PpAnnouncementBar);
}
